import { api } from "../api";
import {
  AdminWorkDepartment,
  AttendanceSource,
  IAdminWorkItem,
  IAttendanceReport,
  ICreditReport,
  IFinanceSummary,
  IPayoutsReport,
} from "common/models/admin/IReports";

interface IRangeParams {
  date_from?: string;
  date_to?: string;
}

const adminReportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFinanceSummary: build.query<IFinanceSummary, IRangeParams>({
      query(params) {
        return { url: `/admin/finance/summary`, params };
      },
    }),
    getCreditReport: build.query<ICreditReport, { query?: string }>({
      query(params) {
        return { url: `/admin/finance/credit`, params };
      },
    }),
    getPayoutsReport: build.query<IPayoutsReport, { query?: string }>({
      query(params) {
        return { url: `/admin/finance/payouts`, params };
      },
    }),
    getAdminWork: build.query<
      IAdminWorkItem[],
      IRangeParams & { department?: AdminWorkDepartment }
    >({
      query(params) {
        return { url: `/admin/admin-work`, params };
      },
      transformResponse: (result: { items: IAdminWorkItem[] }) => result.items,
    }),
    getAttendance: build.query<
      IAttendanceReport,
      IRangeParams & { source?: AttendanceSource }
    >({
      query(params) {
        return { url: `/admin/attendance`, params };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetFinanceSummaryQuery,
  useGetCreditReportQuery,
  useGetPayoutsReportQuery,
  useGetAdminWorkQuery,
  useGetAttendanceQuery,
} = adminReportsApi;
